import View from "../account/views/auth/ResetPasswordFormView";
import components from "./components.js";
components.define("js-resetpassword-form", View);